import React from "react";
import {
  FaBox,
  FaCheckCircle,
  FaFileInvoice,
  FaTruck,
  FaShippingFast,
  FaClock,
} from "react-icons/fa";

const orderSteps = [
  { key: 1, label: "Order Placed", description: "Order confirmed and payment processed", icon: <FaBox /> },
  { key: 2, label: "Supplier accepted", description: "Items picked and prepared for shipment", icon: <FaCheckCircle /> },
  { key: 3, label: "Invoice raised", description: "Package is on the way to destination", icon: <FaFileInvoice /> },
  { key: 4, label: "Shipped", description: "Package dispatched from warehouse", icon: <FaTruck /> },
  { key: 9, label: "Out for Delivery", description: "Package will be delivered today", icon: <FaShippingFast /> },
  { key: 10, label: "Delivered", description: "Package delivered successfully", icon: <FaClock /> },
];

const OrderTracker = ({ currentStep = 2, OrdersData = {} }) => {
  const history = OrdersData?.status_history || [];

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    return d.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getStatusDate = (statusKey) => {
    const found = history.find((h) => Number(h.status) === Number(statusKey));
    return found ? found.created_at : null;
  };

  const currentStatus = Number(OrdersData?.status);

  return (
    <div
      className="card p-4 mb-3"
      style={{
        borderRadius: "12px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
      }}
    >
      <h6 className="mb-3">Order Timeline</h6>

      {orderSteps.map((step) => {
        const date = getStatusDate(step.key);
        const done = currentStatus >= step.key;
        const formatted = date ? formatDateTime(date) : "";

        return (
          <div
            key={step.key}
            className="d-flex align-items-start mb-4"
            style={{
              opacity: done ? 1 : 0.6,
            }}
          >
            {/* Left icon */}
            <div
              className="d-flex justify-content-center align-items-center rounded-circle me-3"
              style={{
                width: 36,
                height: 36,
                backgroundColor: done ? "#22c55e33" : "#f1f3f5",
                color: done ? "#22c55e" : "#adb5bd",
                fontSize: 16,
              }}
            >
              {step.icon}
            </div>

            {/* Text and Date */}
            <div className="flex-grow-1 d-flex justify-content-between align-items-start">
              <div>
                <div
                  style={{
                    fontWeight: 600,
                    color: done ? "#111827" : "#6c757d",
                    fontSize: 15,
                  }}
                >
                  {step.label}
                </div>
                <div
                  style={{
                    fontSize: 13,
                    color: done ? "#6c757d" : "#adb5bd",
                  }}
                >
                  {step.description}
                </div>
              </div>

              <div style={{ fontSize: 13, color: "#6c757d", textAlign: "right" }}>
                {formatted}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OrderTracker;
